import moment from 'moment';
import styled from 'styled-components';

import { useTheme } from '../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../Styles/theme';

import PointManagementView from '../../Model/Individual/StatisticsModel/PointManagementView';

import IntroMarkdown from './IntroMarkdown';

export default function PointManagementRenderer(props) {
  const { data } = props;

  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;

  const { intro, startDate, endDate, totalIssuedPoint, totalUsedPoint, totalHeldPoint, holdings, histories } = data;

  // View 공용 props로 재구성 (통계 point/statistics 응답과 동일 shape) //
  const pointData = {
    totalIssuedPoint: totalIssuedPoint ?? 0,
    totalUsedPoint: totalUsedPoint ?? 0,
    totalHeldPoint: totalHeldPoint ?? 0,
    holdings: holdings || [],
    histories: histories || [],
  };

  // 조회 기간 타이틀 (YY.MM.DD - YY.MM.DD) //
  function calcDateText() {
    if (!startDate || !endDate) return '';

    return moment(startDate).format('YY.MM.DD') + ' - ' + moment(endDate).format('YY.MM.DD');
  }

  return (
    <TopLevelWrapper>
      <IntroMarkdown text={intro} color={theme.text} />
      <ContentWrapper $isDark={isDark}>
        <PointManagementView
          calcDateText={calcDateText}
          pointData={pointData}
          selectedPartnerGym={undefined}
          isOpenPartnerGymSales={true}
          isPointLoading={false} />
      </ContentWrapper>
    </TopLevelWrapper>
  );
}

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  width: 100%;

  gap: 12px;
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;

  align-items: flex-start;

  padding: 20px 24px;

  width: calc(100% - 48px);

  border-radius: 12px;
  background-color: ${props => props.theme.subBackground};
`;
